var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckYellow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd110",
    fillRule: "evenodd",
    d: "M59.971 30.662L34.03 54.873c-.685.63-1.743.63-2.404-.045l-8.638-8.645a1.724 1.724 0 0 1 0-2.445 1.724 1.724 0 0 1 2.445 0l7.463 7.463 24.716-23.067a1.728 1.728 0 1 1 2.359 2.528M41.5 0C18.616 0 0 18.623 0 41.5 0 64.38 18.616 83 41.5 83 64.38 83 83 64.38 83 41.5 83 18.623 64.38 0 41.5 0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckYellow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-yellow.3a68855d5c5e81ab1889480f94d57d20.svg";